export { SectionContainer } from './component';
export {
  TITLE_HEADING_H1,
  TITLE_HEADING_H2,
  TITLE_HEADING_H3,
} from './constants';
export type { Component, Props, TitleHeading } from './types';
